import React from "react";
import SuggestionsPickerSelectedProps from "./SuggestionsPickerSelectedProps";
import CircleXSvg from "../../../svg/CircleXSvg";
import AmazonLogoSvg from "../../../svg/AmazonLogoSvg";
import styles from "../../auto-suggest.module.css";

const TeamPickerSelected: React.FC<SuggestionsPickerSelectedProps> = ({
  selectedItem,
  clearSelected,
  disabled,
  isSquare,
}): JSX.Element => {
  const holderStyle = disabled
    ? `${styles["team-picker"]} ${styles["suggestions-picker-replacement-disabled"]}`
    : styles["team-picker"];

  const selectedElement = (
    <div className={isSquare ? styles["square"] : styles["round"]}>
      <div className={holderStyle}>
        <div className={styles["headshot-cropper-centered"]}>
          <AmazonLogoSvg />
        </div>
        <div className={styles["suggestions-picker-replacement-text"]}>
          {selectedItem && (
            <div>
              <span>{selectedItem.title}</span>
              <div className={styles["team-picker-path-text"]}>
                {selectedItem.detail}
              </div>
            </div>
          )}
        </div>
        {selectedItem && !disabled && (
          <div
            className={styles["suggestions-picker-replacement-circle-holder"]}
            onClick={clearSelected}
          >
            <CircleXSvg />
          </div>
        )}
      </div>
    </div>
  );

  return <React.Fragment>{selectedElement}</React.Fragment>;
};

export default TeamPickerSelected;
